import React, { useEffect } from "react";
import ProjectsListNew from "../components/project/projects/ProjectsListNew";
import { loadStakes } from "../components/stake/actions/stakeAction";
import { loadAllAxis } from "../components/axis/all-axis/axisAction";
import FunctionalPage from "./FunctionalPage";
import { useDispatch, useSelector } from "react-redux";
import { loadProjects } from "../components/project/projects/projectsAction";
import {loadAllTagCategories} from "../components/tag/tagCategory/tagCategoryAction";
import {loadUsers} from "../components/user/usersAction";

const ProjectsPage2 = () => {
  const dispatch = useDispatch();
  const { id: currentUserId } = useSelector((state) => state.currentUser);

  useEffect(() => {
    dispatch(loadAllAxis());
    dispatch(loadStakes());
    dispatch(loadProjects(currentUserId));
    dispatch(loadAllTagCategories());
    dispatch(loadUsers());

  }, [currentUserId, dispatch]);

  return <FunctionalPage title={""} component={<ProjectsListNew />} />;
};

export default ProjectsPage2;
